import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export const cleanControlValidations = (
	form: UntypedFormGroup | UntypedFormArray,
	controlKey: string,
	validations: string[]
): void => {
	validations.forEach((validation: string) => delete form?.controls[controlKey]?.errors[validation]);

	if (Object.keys(form?.controls[controlKey]?.errors).length === 0) {
		form?.controls[controlKey].setErrors(null);
	}
};
